import {
  objectSchema,
  optionalTolerant,
  tolerantArray,
} from '../../_utils/fcdc-v2'
import { i18nStringSchema } from './i18n-string.schema'
import * as z from 'zod'

export const contactPersonSchema = objectSchema({
  name: optionalTolerant(z.string()),
  phoneNumber: optionalTolerant(z.string()),
  emailAddress: optionalTolerant(z.string()),
  notes: optionalTolerant(tolerantArray(i18nStringSchema)),
})
